export default __webpack_public_path__ + "assets/images/180539392e0f162b63a10bb0590f7b0b.jpg";